// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adjustWidth[data-v-a5820716] {\n  width: -webkit-max-content;\n  width: -moz-max-content;\n  width: max-content;\n  margin-left: 32px;\n  font-size: 12px;\n  margin-top: -5px;\n}\n.customCardConatiner[data-v-a5820716] {\n  margin-bottom: 8px !important;\n  -webkit-box-shadow: none !important;\n          box-shadow: none !important;\n  padding: 16px 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
